import Header from '../Header/Header'
import Footer from '../footer/Footer'
import './main.css'

import motivationimg from '../../utils/motivation.png'
import FreeCoursesOnMain from './FreeCoursesOnMain'

const Main = () => {
  return (
    <>
      <Header />
      <div className="main-container">
        <div className="main-search-blok">
          <h1>Список Курсов</h1>
          <p>Учись ради навыков, а не сертификатов.</p>
        </div>

        <FreeCoursesOnMain />

        <div className="advice">
          <h1>"Окуу окуу жана окуу"</h1>
          <img src={motivationimg} alt="motivationimg" />
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Main
